import PropTypes from "prop-types";
import { isNil, isEmpty } from "ramda";

import InvitePresenter from "presenters/InvitePresenter";

const CollapsableField = ({ field, invite, children }) => {
  const fieldValue = InvitePresenter?.[field](invite);
  // collapse content if the invite event info has been updated and the field value is null or empty
  const collapse = InvitePresenter.isEventUpdated(invite) && (isNil(fieldValue) || isEmpty(fieldValue));

  return collapse ? null : children;
};

CollapsableField.propTypes = {
  field: PropTypes.string.isRequired,
  invite: PropTypes.shape(),
};

export default CollapsableField;
